import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { push } from 'react-router-redux'
import queryString from 'query-string'
import PropTypes from 'prop-types'
import { Table, TableCell, TableHeader, TableLoading, Button, RoundedTabs, Modal, Pagination } from 'advenio-components'
import InscriptionsActions from '../../Data/Redux/InscriptionsRedux'
import ReinscriptionModal from './ReinscriptionModal'
import DeleteStudentModal from './DeleteStudentModal'
import EnrollActions from '../../Data/Redux/EnrollRedux'
import ClassroomActions from '../../Data/Redux/ClassroomRedux'
import AllCentersActions from '../../Data/Redux/AllCentersRedux'
import StudyProgramsActions from '../../Data/Redux/StudyProgramsRedux'
import CenterProductsActions from '../../Data/Redux/CenterProductsRedux'

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  `

const PaginationContainer = styled.div`
  margin: 12px 0;
`

const TableContainer = styled.div`
  width: 100%;
  margin-top: 30px;
  padding-left: 24px;
  padding-right: 24px;
`

const CellContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color:#FFFFFF;
  height: 100%;
`
const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 80%;
  height: 100%;
`
const PhotoContainer = styled.div`
  width: 30%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
const NameContainer = styled.div`
  width: 80%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  cursor: ${props => props.classroom ? 'pointer':''};

`
const Photo = styled.div`
  background-image: ${props => props.profile_image ? 'url(' + props.profile_image + ')' : ''};
  background-size: cover;
  background-position: center;
  width: 40px;
  height: 40px;
  border-radius: 10%;
  border:  solid #CCCCCC 1px;
`
const HeaderContainer = styled.div`
  width: 100%;
  height: 60px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
`

class Inscriptions extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeId: null,
      activeClassroomid: null,
      isOpened: false,
      deleteStudent: false,
      parents: null,
      activeChild: null,
      firstPageToRender: 1,
      lastPageToRender: 10,
      pageSelected: 1,
      queryParams: {},
      center: null,
    }
  }

  componentWillMount() {
    const queryParams = queryString.parse(this.props.location.search)
    if (queryParams.page) {
      this.setState({ pageSelected: Number(queryParams.page) })
    }
    this.setState({ queryParams })
    this.props.getInscriptions(queryParams)
    this.props.getClassrooms({'basic':true,'students':false})
    this.props.getStudyPrograms(this.props.user.center_id)
    this.props.getCenterProducts(this.props.user.center_id)
    this.props.getAllCenters()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.centers) {
      const selectedCenter = nextProps.centers.find(c => c.id === nextProps.user.center_id)
      this.setState({ center: selectedCenter })
    }
  }

  onClick = (id) => {
    const [selectedChild] = this.props.inscriptions.filter(child => child.id == id)
    this.setState({ 
      activeId: id,
      isOpened: true,
      parents: selectedChild.parents ,
      activeClassroomid:selectedChild.classroom_id
    })
  }
  viewProfile = (profileId,classroom) =>{
    this.props.setActiveStudentId(Number(profileId))
    this.props.setActiveClassroomId(Number(classroom))
    if(classroom){
      this.props.history.push(`classroom/${classroom}/student/${profileId}`)
    }
  }

  onClickPage = (page) => {
    this.setState({ pageSelected: page }, () => {
      const { queryParams } = this.state
      const { getInscriptions, goTo } = this.props

      const queries = { ...queryParams, page }
      getInscriptions(queries)
      goTo(`?${queryString.stringify(queries)}`)
    })
  }

  onClose = () => {
    this.setState({ isOpened: false, deleteStudent: false })
  }

  getChildInfo = (id, classroom, name, paternalLastname, maternalLastname, parent, image) => {
    let profile = ''
    const childName = name || ''
    const childMaternalLastName = maternalLastname || ''
    const childPaternalLastName = paternalLastname || ''
    if (image === '') {
      profile = '/assets/BabyAvatar.svg'
    } else {
      profile = image
    }

    return (
      <InfoContainer>
        <PhotoContainer>
          <Photo profile_image={profile} />
        </PhotoContainer>
        <NameContainer classroom={classroom} onClick={(e)=>{this.viewProfile(id,classroom)}}  >
          <span style={{ marginBottom: '2px', textOverflow: 'ellipsis' }}>{`${childName}  ${childPaternalLastName}  ${childMaternalLastName}`}</span>
          <span style={{ color: '#4A4A4A' }}>{`Tutor:  ${parent.length>0 ? parent[0].full_name:''}`}</span>
        </NameContainer>
      </InfoContainer>
    )
  }

  getCompanyParent = parent => {
    const { companies } = this.props
    const [companySelected] = companies.filter(company => company.id === parent.company_id)
    return (
      <InfoContainer>
        <NameContainer>
          <span style={{ marginBottom: '2px', textOverflow: 'ellipsis' }}>{`${companySelected ? companySelected.name :'Sin Empresa'} `}</span>
          {/* <span style={{ color: '#4A4A4A' }}>{`Tutor:  ${parent.length>0 ? parent[0].full_name:''}`}</span> */}
        </NameContainer>
      </InfoContainer>
    )
  }
  getClassroomStudent = classroomId => {
    const { classrooms } = this.props
    const classroomSelected = classrooms.find(c=> c.id === Number(classroomId))
    if(classrooms.length > 0  && classroomSelected !== undefined){
      return (
      <div>
        <span style={{ marginBottom: '2px', textOverflow: 'ellipsis' }}>{`${classroomSelected.type === 'External' ? 'Externo' : 'Centro'} `}</span>
        {/* <span style={{ color: '#4A4A4A' }}>{`Tutor:  ${parent.length>0 ? parent[0].full_name:''}`}</span> */}
      </div>
      )
    }
  }

  goTo = (e) => {
    this.props.goTo(e.currentTarget.id)
  }

  openDeleteStudent = (e) => {
    const [selectedChild] = this.props.inscriptions.filter(child => child.id == e.target.id)
    this.setState({ 
      activeId: e.target.id,
      deleteStudent: true,
      activeChild: `${selectedChild.first_name} ${selectedChild.last_name_paternal}` })
  }

  deleteStudent = (id, comment) => {
    const params = {
      comments: comment,
    }
    this.props.deleteEnroll(id, params)
  }


  render() {
    const { centerProducts, studyPrograms, classrooms, meta } = this.props
    const { pageSelected, center } = this.state
    return (
      <Container>
        <TableContainer>
          <HeaderContainer>
            <RoundedTabs
              selectedTab={'/enrollments'}
              tabs={[
                {
                  id: '/enrollments',
                  title: 'Inscripciones',
                },
                {
                  id: '/reinscriptions',
                  title: 'Reinscripciones',
                },
                {
                  id: '/reservations',
                  title: 'Reservaciones',
                },
                {
                  id: '/disenrollments',
                  title: 'Bajas',
                },
              ]}
              onClick={this.goTo}
            />
          </HeaderContainer>
          <PaginationContainer>
            <Pagination
              totalElements={meta && meta.total}
              elementsPerPage={meta && meta.per_page}
              onPageClick={this.onClickPage}
              pageSelected={pageSelected}
            />
          </PaginationContainer>
          {this.props.loading ?
            <TableLoading
              roundedCorners
              columns={[
                {
                  id: 1,
                  header: 'Alumno y Tutor',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 2,
                  header: '¿Quién Atendió?',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 3,
                  header: 'Empresa',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 4,
                  header: 'Tipo de alumno',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 5,
                  header: 'Acciones',
                  element: 'Text',
                  center: true,
                },
              ]}
              rows={10}
            />
            :
            <Table
              data={this.props.inscriptions}
              columns={[
                {
                  id: '1',
                  Header: () => <TableHeader title="Alumno y Tutor" center blue />,
                  accessor: ({id, classroom_id, first_name, parents, last_name_paternal, last_name_maternal }) =>
                    ({id, classroom_id, first_name, parents, last_name_paternal, last_name_maternal }),
                  Cell: ({ value: {id, classroom_id, first_name, parents, last_name_paternal, last_name_maternal } }) => <CellContainer>{this.getChildInfo(id, classroom_id, first_name, last_name_paternal, last_name_maternal, parents, '')}</CellContainer>,
                },
                {
                  id: '2',
                  Header: () => <TableHeader title="¿Quién Atendió?" center blue />,
                  accessor: ({ assigned_to }) => ({ assigned_to }),
                  Cell: ({ value: { assigned_to } }) =>
                    <CellContainer><span>{assigned_to}</span></CellContainer>,
                },
                {
                  id: '3',
                  Header: () => <TableHeader title="Empresa" center blue />,
                  accessor: ({ parents }) => ({ parents }),
                  Cell: ({ value: { parents } }) =>
                    <CellContainer>{this.getCompanyParent(parents[0])}</CellContainer>,
                },
                {
                  id: '4',
                  Header: () => <TableHeader title="Tipo de alumno" center blue />,
                  accessor: ({ classroom_id }) =>
                    ({ classroom_id}),
                  Cell: ({ value: { classroom_id } }) =>
                    <CellContainer>{this.getClassroomStudent(classroom_id)}</CellContainer>,
                },
                {
                  id: '5',
                  Header: () => <TableHeader title="Acciones" center blue />,
                  accessor: ({ first_name, id, last_name_paternal, last_name_maternal }) =>
                    ({ first_name, id, last_name_paternal, last_name_maternal }),
                  Cell: ({ value: { id } }) => 
                  <TableCell center>
                    <Button 
                      disabled={!(centerProducts.length > 0 && studyPrograms.length > 0 && classrooms.length > 0)} 
                      loading={!(centerProducts.length > 0 && studyPrograms.length > 0 && classrooms.length > 0)} 
                      success 
                      small 
                      id={id} 
                      onClick={() => this.onClick(id)}
                    >
                      <span 
                        style={{ padding: '0px 5px' }} 
                        id={id}
                      >
                        Inscribir
                      </span>
                    </Button>
                    <Button danger small id={id} onClick={this.openDeleteStudent}>
                      <span style={{ padding: '0px 5px' }} id={id}>Borrar</span>
                    </Button>
                  </TableCell>,
                }
              ]}
            />
          }
        </TableContainer>
        <Modal
          isOpened={this.state.isOpened &&
            centerProducts.length > 0 && studyPrograms.length > 0 && classrooms.length > 0}
          onClose={this.onClose}
          headerTitle="Inscribir Alumno"
          statePath="enroll"
          actionType="sending"
          typePrefix="ENROLL"
        >
          <ReinscriptionModal
            id={this.state.activeId}
            activeClassroomid={this.state.activeClassroomid}
            classrooms={this.props.classrooms}
            studyPrograms={this.props.studyPrograms}
            parents={this.state.parents}
            type="enroll"
            products={this.props.centerProducts}
            closeModal={this.onClose}
            needsCurp={center && center.requires_tax_id}
          />
        </Modal>
        <Modal
          isOpened={this.state.deleteStudent}
          onClose={this.onClose}
          headerTitle="Eliminar Alumno"
          statePath="enroll"
          actionType="sending"
          typePrefix="ENROLL"
        >
          <DeleteStudentModal
            closeModal={this.onClose}
            delete={this.deleteStudent}
            activeId={this.state.activeId}
            student={this.state.activeChild}
          />
        </Modal>
      </Container>
    )
  }
}

Inscriptions.propTypes = {
  loading: PropTypes.bool.isRequired,
  inscriptions: PropTypes.array,
  classrooms: PropTypes.array.isRequired,
  getInscriptions: PropTypes.func.isRequired,
  getClassrooms: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
  deleteEnroll: PropTypes.func.isRequired,
  getStudyPrograms: PropTypes.func.isRequired,
  getCenterProducts: PropTypes.func.isRequired,
  studyPrograms: PropTypes.array.isRequired,
  centerProducts: PropTypes.array.isRequired,
  meta: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]),
  location: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]),
  user: PropTypes.object.isRequired,
}

Inscriptions.defaultProps = {
  inscriptions: [],
  meta: () => {},
  location: {},
}

const mapStateToProps = state => ({
  loading: state.inscriptions.get.fetching,
  meta: state.inscriptions.get.results.meta,
  links: state.inscriptions.get.results.links,
  inscriptions: state.inscriptions.get.results.data,
  classrooms: state.classrooms.get.results,
  user: state.auth.user,
  studyPrograms: state.study_programs.get.results,
  centerProducts: state.center_products.get.results,
  centers: state.allCenters.get.results,
  companies: state.companies.get.results
})

const mapDispatchToProps = dispatch => ({
  getInscriptions: query => dispatch(InscriptionsActions.getRequest(query)),
  getAllCenters: () => dispatch(AllCentersActions.getRequest()),
  getClassrooms: (query) => dispatch(ClassroomActions.getRequest(query,true)),
  setActiveStudentId: id => dispatch(ClassroomActions.setActiveStudentId(id)),
  setActiveClassroomId: id => dispatch(ClassroomActions.setActiveClassroomId(id)),
  goTo: path => dispatch(push(path)),
  deleteEnroll: (studentId, data) => dispatch(EnrollActions.deleteEnrollRequest(studentId, data)),
  getStudyPrograms: centerId => dispatch(StudyProgramsActions.getRequest(centerId)),
  getCenterProducts: centerId => dispatch(CenterProductsActions.getRequest(centerId)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Inscriptions))



// WEBPACK FOOTER //
// ./src/Containers/Inscriptions/Inscriptions.jsx